export const defaultPreviewTemplate = `<%= question.topic.reteyner.name %>`;
